// Snippets from : https://threejs.org/examples/webgl_materials_video.html
import * as THREE from 'three';

let domElement;

let camera, scene, renderer;

let meshes = [];
let cubes = [];
let materials = [];

let gridSizes;
let totalW;
let totalH;

let groups = [];


let pointer = new THREE.Vector2();
let raycaster = new THREE.Raycaster();
function handleMouseMove(event) {
	pointer.x = ( event.clientX / window.innerWidth ) * 2 - 1;
	pointer.y = - ( event.clientY / window.innerHeight ) * 2 + 1;

	if(camera){
		raycaster.setFromCamera( pointer, camera );
		for (let u = 0; u < gridSizes.length; u++) {
			const intersections = raycaster.intersectObjects( cubes[u], false );
			const intersection = ( intersections.length ) > 0 ? intersections[ 0 ] : null;
			if ( intersection !== null && intersection.object.visible) {
				for (let i = 0; i < cubes[u].length; i++) {
					if(cubes[u][i].id === intersection.object.id){
						intersectCube(u+1, cubeObjs[u][i], intersection.object.id);
					}
				}
			}
		}
	}
}

let selectedCallBack;
function intersectCube(cubeIndex, cubeObject, cubeId){
	selectedCallBack(cubeIndex, cubeObject.groupId, cubeObject);
}


export const init = (el, _gridSizes, _totalW, _totalH, _camera, objects, textures, _selectedCallBack) => {
	domElement = el;
	totalW = _totalW;
	totalH = _totalH;
	gridSizes = _gridSizes;
	selectedCallBack = _selectedCallBack;

	camera = _camera;
	setupThree(objects, textures);

	window.addEventListener('resize', resize);
}


function setupThree(objects, textures) {
	scene = new THREE.Scene();
	
	for (let u = 0; u < objects.length; u++) {
		scene.add( objects[u] );
	}

	renderer = new THREE.WebGLRenderer();
	renderer.setPixelRatio( window.devicePixelRatio );
	renderer.setSize( window.innerWidth, window.innerHeight );
	

	// const vidTexture = new THREE.VideoTexture( document.getElementById( 'video' ) );
	// const parameters = { color: 0xffffff, map: vidTexture };
	
	cubes = [];
	materials = [];

	for (let u = 0; u < gridSizes.length; u++) {

		cubes[u] = [];
		materials[u] = [];
		let geometry;

		const xgrid = gridSizes[u][0];
		const ygrid = gridSizes[u][1];
		const ux = 1 / xgrid;
		const uy = 1 / ygrid;

		let c = 0;

		for ( let i = 0; i < xgrid; i ++ ) {
			for ( let j = 0; j < ygrid; j ++ ) {
				geometry = new THREE.BoxGeometry( totalW / xgrid, totalH / ygrid, 8 );
				geometry.groups[0].materialIndex = 0; 
				geometry.groups[1].materialIndex = 0; 
				geometry.groups[2].materialIndex = 0; 
				geometry.groups[3].materialIndex = 0; 
				geometry.groups[4].materialIndex = 0; // front
				geometry.groups[5].materialIndex = 1; // back

				change_uvs( geometry, ux, uy, i, j );

				materials[u][c] = [
					// new THREE.MeshLambertMaterial( parameters ),
					new THREE.MeshLambertMaterial( { map: textures[0], emissive: 0x000000  } ),
					new THREE.MeshLambertMaterial( { map: textures[1], emissive: 0x000000  } )
				];
				meshes[u] = new THREE.Mesh( geometry, materials[u][c] );

				if(groups[j] == undefined){
					groups[j] = new THREE.Group();
					scene.add( groups[j] );
				}
				groups[j].add( meshes[u] );

				cubes[u][c] = meshes[u];
				c += 1;
			}
			renderer.autoClear = false;
		}
	}
	
	window.addEventListener('pointermove', handleMouseMove);
};

function change_uvs( geometry, unitx, unity, offsetx, offsety ) {
	const uvs = geometry.attributes.uv.array;
	for ( let i = 0; i < uvs.length; i += 2 ) {
		uvs[ i ] = ( uvs[ i ] + offsetx ) * unitx;
		uvs[ i + 1 ] = ( uvs[ i + 1 ] + offsety ) * unity;
	}
}

let h, counter = 1;
let cubeObjs;
export const update = (texturedBoxes, groupObjects) => {
	const time = Date.now() * 0.0005;
	cubeObjs = texturedBoxes;

	for (let u = 0; u < gridSizes.length; u++) {
		const cubeCount = gridSizes[u][0] * gridSizes[u][1];
		for (let i = 0; i < cubeCount; i++) {

			// const 4 = meshes[ i ];
			const mesh = cubes[u][ i ];
			const c = texturedBoxes[u][i];
			mesh.position.copy(c.position);
			mesh.rotation.x = c.rotation.x + c.addRot.x;
			mesh.rotation.y = c.rotation.y + c.addRot.y;
			mesh.rotation.z = c.rotation.z + c.addRot.z;
			mesh.scale.copy(c.scale);

			mesh.visible = c.visible;

			materials[u][i][0].color.setHSL(c.hslFront.x, c.hslFront.y, c.hslFront.z);
			materials[u][i][1].color.setHSL(c.hslBack.x, c.hslBack.y, c.hslBack.z);
		}
	}

	for (let i = 0; i < groupObjects.length; i++) {
		const gO = groups[i];
		const g = groupObjects[i];
		gO.position.copy(g.position);
		gO.rotation.copy(g.rotation);
		gO.scale.copy(g.scale);
	}

	renderer.render( scene, camera );
}

const resize = () => {
	renderer.setSize(window.innerWidth, window.innerHeight)
	camera.aspect = window.innerWidth / window.innerHeight;
	camera.updateProjectionMatrix();
};


export const drawGL = () => {
	renderer = new THREE.WebGLRenderer({antialias: true, canvas: domElement});
	resize();
}